import React from 'react';
import './loader.scss';
import { Spin } from 'antd';

const Loader = () => {
  return (
    <div className='d-flex justify-content-center align-items-center w-100' style={{minHeight: '80vh'}}>
      <Spin spinning={true} />
    </div>
    // <div className="loader-wrap">
    //   <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
    //     <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z" />
    //   </svg>
    //   <div className="loader-wrap-heading">
    //     <div className="load-text">
    //       <span>L</span>
    //       <span>o</span>
    //       <span>a</span>
    //       <span>d</span>
    //       <span>i</span>
    //       <span>n</span>
    //       <span>g</span>
    //     </div>
    //   </div>
    // </div>
  );
};
export default Loader;
